import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
  output,
} from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { OfferSimpleListItem, OfferStatus, StatusChangeType } from '@core/offers-types';
import { OfferStatusComponent } from '@core/offers-ui';
import {
  ButtonComponent,
  ButtonDropdownIndicatorDirective,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownHeaderComponent,
  DropdownItemComponent,
  DropdownWidth,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-statuses-dropdown',
  templateUrl: './statuses-dropdown.component.html',
  styleUrls: ['./statuses-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownHeaderComponent,
    DropdownItemComponent,
    OfferStatusComponent,
    OverlayOriginDirective,
    TranslatePipe,
    ButtonDropdownIndicatorDirective,
    ButtonComponent,
  ],
})
export class StatusesDropdownComponent {
  private readonly cdRef = inject(ChangeDetectorRef);

  protected readonly StatusChangeType = StatusChangeType;
  protected readonly OfferStatus = OfferStatus;
  protected readonly DropdownWidth = DropdownWidth;

  public offer = input.required<OfferSimpleListItem>();
  public state = input<'read-only' | 'default'>('default');
  public hasPublishActions = input(false);
  public isPlain = input(true);

  public action = output<StatusChangeType>();

  protected openStatusDropdown(dropdown: ConnectedOverlayDirective): void {
    if (this.state() !== 'default') return;
    dropdown.open = !dropdown.open;
    this.cdRef.detectChanges();
  }

  protected changeStatus(name: StatusChangeType): void {
    if (this.state() !== 'default') return;
    this.action.emit(name);
  }
}
